/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { css, jsx } from '@emotion/react'

import type { EuiFlexGroupProps } from '@elastic/eui'
import { EuiFlexGroup, EuiFlexItem, EuiText, useEuiTheme } from '@elastic/eui'

import type { FunctionComponent, ReactNode } from 'react'

interface Props {
  label: ReactNode
  alignItems?: EuiFlexGroupProps['alignItems']
  children: ReactNode
  labelColor?: 'subdued' | 'warning'
  wideLabel?: boolean
}

const TopologyPanelRow: FunctionComponent<Props> = ({
  label,
  alignItems = 'flexStart',
  children,
  labelColor = 'subdued',
  wideLabel,
}) => {
  const { euiTheme } = useEuiTheme()

  return (
    <EuiFlexGroup gutterSize='l' alignItems={alignItems} responsive={false}>
      <EuiFlexItem grow={1} css={wideLabel ? { minWidth: 255 } : undefined}>
        <EuiText
          size='s'
          color={labelColor}
          css={css({
            textAlign: 'right',
            [`@media screen and (max-width: ${euiTheme.breakpoint.m}px)`]: {
              textAlign: 'left',
            },
          })}
        >
          {label}
        </EuiText>
      </EuiFlexItem>
      <EuiFlexItem grow={4}>{children}</EuiFlexItem>
    </EuiFlexGroup>
  )
}

export default TopologyPanelRow
